import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from 'yup';
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from "react-bootstrap";
import { IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useSelector } from "react-redux";
import editProfileService from "../../../components/Services/editProfile.service";
import signUpService from "../../../components/Services/signUp.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import { useNavigate } from "react-router";

const EditProfile = () => {
  const [showEditMyProfileModal, setShowEditMyProfileModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [myProfileDetails, setMyProfileDetails] = useState([])

  const isLoggedIn = useSelector(state => state?.sessionState?.role)

  const handleClickCurrentPassword = () => setCurrentPassword((show) => !show);
  const handleClickPassword = () => setShowPassword((show) => !show);
  const handleClickConfirmPassword = () => setShowConfirmPassword((show) => !show);

  const initialValues = {
    currentPassword: "",
    newPassword:"",
    confirmPassword:"",
  };

  const editMyprofileModal = () => {
    setShowEditMyProfileModal(true);
  }

  const editMyProfileModalClose = () => {
    setShowEditMyProfileModal(false);
  }

  const changePasswordModal = () => {
    setShowChangePasswordModal(true);
  }
  const changePasswordModlaClose = () => {
    setShowChangePasswordModal(false);
  }
  const getMyProfileDetails = () => {
    editProfileService.getMyProfileDetails().then((response) => {
      if (response?.data?.code === 200) {
        setMyProfileDetails(response?.data?.data)
      }
    })
  }
  useEffect(() => {
    getMyProfileDetails();
  }, [])
  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string()
      .required("Current Password is required"),
  
    newPassword: Yup.string()
      .required("New Password is required")
      .min(6, "New Password must be at least 6 characters long")
      .test('not-same-as-current', 'New Password cannot be the same as Current Password', function(value) {
        // 'this' refers to the schema
        const currentPassword = this.parent.currentPassword; // Get the value of 'currentPassword'
        return value !== currentPassword;
      }).matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/,
    "Password size must be 8-20 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character."
      ),
  
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref('newPassword'), null], "Password must match New Password"),
  });
  const navigate = useNavigate()
  return (
    <>
      <div className="capacity-card mb-3">
        {showChangePasswordModal && <Modal
          show={showChangePasswordModal}
          onHide={changePasswordModlaClose}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                let reqBody = {
                  "oldPassword":values.currentPassword,
                  "newPassword": values.newPassword,
                  "confirmNewPassword": values.confirmPassword,
                }
                signUpService.updatePassword(reqBody).then((response)=>{
                  if(response?.data?.code === 200){
                    setShowChangePasswordModal(false);
                    toast.success(response?.data?.message,toastProperties);
                    navigate("/")
                  }
                })
              }}
                >
              {({ values, setFieldValue, setFieldTouched, setValues }) => {
                return <Form>
            <div className="p-4" >
              <div className="fw-bold">Enter a New Password Below to Change Your Password</div>
              <div className="mt-3 position-relative">
                <label className="fw-medium">Current Password:</label>
                <Field type={currentPassword ? 'text' : 'password'} className=" custom-input" name="currentPassword"  autoComplete="off" />
                <IconButton className="eye_icon" onClick={handleClickCurrentPassword}>
                  {currentPassword ? <Visibility /> : <VisibilityOff /> }
                </IconButton>
              </div>
              <ErrorMessage name='currentPassword' className='text-danger' component='div' />
              <div className="mt-3 position-relative">
                <label className="fw-medium">New Password:</label>
                <Field type={showPassword ? 'text' : 'password'} className=" custom-input" name="newPassword"
                />
                <IconButton className="eye_icon" onClick={handleClickPassword}>
                  {showPassword ? <Visibility /> : <VisibilityOff /> }
                </IconButton>
              </div>
              <ErrorMessage name='newPassword' className='text-danger' component='div' />
              <div className="mt-3 position-relative">
                <label className=" fw-medium">Confirm Password:</label>
                <Field type={showConfirmPassword ? 'text' : 'password'} className=" custom-input" name="confirmPassword"
                  
                />
                <IconButton className="eye_icon" onClick={handleClickConfirmPassword}>
                  {showConfirmPassword ? <Visibility /> : <VisibilityOff /> }
                </IconButton>
              </div>
              <ErrorMessage name='confirmPassword' className='text-danger' component='div' />
              <button type="submit" className="btn btn-signup btn-primary py-3 mt-3">Change Password</button>
            </div>
            </Form>
           }}
           </Formik>
          </Modal.Body>
        </Modal>}
      </div>
      {showEditMyProfileModal && <Modal
        show={showEditMyProfileModal}
        onHide={editMyProfileModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="edit-profile-modal-content py-4">
            <img src="images/edit_profile_img.png" width={150} alt="Edit Profile" />
            <div className="edit-profile-write text-center">Please write to admin@gna.energy to make any changes to your profile</div>
            {/* <button type="button" className="btn btn-signup btn-primary py-3 mb-3">Send Request</button> */}
          </div>
        </Modal.Body>
      </Modal>}
      <div className="container my-4">
        <div className="capacity-card mb-3">
          <div className="capacity-card-body">
            <div className="company-profile-details-wrap">
              {/* <div>
                <img src="images/com-profile-img-2.png" alt="company" />
              </div> */}
              <div className="company-profile-rside w-75">
                <div className="company-profile-gst">
                <div>Member ID - {myProfileDetails?.userResponse?.memberId}</div>
                </div>
                <h4 className="company-profile-title">{myProfileDetails?.companyResponse?.name}</h4>
                <div className="company-profile-descprition">
                  {myProfileDetails?.companyResponse?.description}
                </div>
                <div className="company-profile-gst">
                                    <div>GSTIN -{myProfileDetails?.companyResponse?.gst}</div>
                                    <div>TAN - {myProfileDetails?.companyResponse?.tan}</div>
                                    <div>PAN - {myProfileDetails?.companyResponse?.pan}</div>
                                    <br />
                                    <br />
                                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="company-profile-btn-group justify-content-end my-4">
        <button type="button" className="btn btn-login" onClick={editMyprofileModal}>
          <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
          Edit Profile
        </button>
      
      <button type="button" className="btn btn-login" onClick={changePasswordModal}>
        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
        Change Password
      </button>
      {/* <button type="button" className="btn btn-bookmark">
        <i className="fa fa-star-o" aria-hidden="true"></i> My Favourites
      </button> */}
      </div>
        <div className="custom-nav-tabs card-box mt-4">
          <Tabs variant='nav' defaultActiveKey="Details 1" id='company-profile-tab'>
            <Tab eventKey="Details 1" title='Company Information'>
              <div style={{ display: "flex" }}>
                <div className='div-table' style={{ marginRight: "20%" }}>
                  <div className='div-row'>
                    <div className='div-cell'>User Name</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.userResponse?.userName}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Email</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.userResponse?.email}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Phone Number</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.userResponse?.phone}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Credit Rating</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.creditRating?.rating}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Credit Rating Year</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.creditRatingYear}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Credit Rating Agency</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.creditRatingAgency}</div>
                  </div>
                  <div className='div-cell div-cell-black'>Bank Details</div>
                  <div className='div-row'>
                    <div className='div-cell'>Name and Branch Address</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.bankAccounts[0]?.name}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Account Number</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.bankAccounts[0]?.accNo}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Ifsc Code</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.bankAccounts[0]?.ifsc}</div>
                  </div>
                </div>
                <div className='div-table'>
                  <div className='div-cell div-cell-black'>Office Address</div>
                  <div className='div-row'>
                    <div className='div-cell'>Registered Address</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[0]?.address}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>State</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[0]?.stateUt}</div>
                  </div>

                  <div className='div-row'>
                    <div className='div-cell'>City</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[0]?.city}</div>
                  </div>

                  <div className='div-row'>
                    <div className='div-cell'>Pin Code</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[0]?.pin}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Telephone</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[0]?.tel}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Email</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[0]?.email}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Fax Number</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[0]?.fax}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Name Of Contact Person(s)</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[0]?.contactPersons?.join(', ')}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Mobile Number</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[0]?.mob}</div>
                  </div>
                  <div className='div-cell div-cell-black'>Correspondence Address</div>
                  <div className='div-row'>
                    <div className='div-cell'>Address</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[1]?.address}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>State</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[1]?.stateUt}</div>
                  </div>

                  <div className='div-row'>
                    <div className='div-cell'>City</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[1]?.city}</div>
                  </div>

                  <div className='div-row'>
                    <div className='div-cell'>Pin Code</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[1]?.pin}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Telephone</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[1]?.tel}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Email</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[1]?.email}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Fax Number</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[1]?.fax}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Name Of Contact Person(s)</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[1]?.contactPersons?.join(', ')}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Mobile Number</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.addresses[1]?.mob}</div>
                  </div>
                </div>
              </div>
            </Tab>
            {((isLoggedIn === 'GENERATOR' || isLoggedIn === 'UN_VERIFIED_GENERATOR') && myProfileDetails?.companyResponse?.plant && <Tab eventKey="Details 2" title={"Plant Details"}>
              <div style={{ display: 'flex' }}>
                <div className='div-table' style={{ marginRight: "20%" }}>
                  <div className='div-row'>
                    <div className='div-cell'>Generating Type</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.plant?.energyType?.genType}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Energy Type</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.plant?.energyType?.type}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Plant Specification</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>NA</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Project Id</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.plant?.projectId}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Install Capacity</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.plant?.installedCap ? myProfileDetails?.companyResponse?.plant?.installedCap : "NA"}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Control Area</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.plant?.controlArea?.type}</div>
                  </div>
                </div>
                <div className='div-table'>
                  <div className='div-row'>
                    <div className='div-cell'>Point Of Injection</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.plant?.poi?.value}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Poi Location</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.plant?.poiLocation}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Region</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.plant?.region}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>State</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.plant?.stateUt}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Discom</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.plant?.discom?.acronym}</div>
                  </div>
                  <div className='div-row'>
                    <div className='div-cell'>Voltage Level at Discom</div>
                    <div className='div-cell'>:</div>
                    <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.plant?.discomVoltage}</div>
                  </div>
                </div>
              </div>
            </Tab>)}
            {((isLoggedIn === 'CONSUMER' || isLoggedIn === 'UN_VERIFIED_CONSUMER') && <Tab eventKey="Details 2" title={'Consumer Details'}>
              <div className='div-table'>
                <div className='div-row'>
                  <div className='div-cell'>Maximum Capacity Of Drawal</div>
                  <div className='div-cell'>:</div>
                  <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.consumer?.maxCapDrawl ? myProfileDetails?.companyResponse?.consumer?.maxCapDrawl : "NA"}</div>
                </div>
                <div className='div-row'>
                  <div className='div-cell'>Point of Drawal</div>
                  <div className='div-cell'>:</div>
                  <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.consumer?.pod?.value ? myProfileDetails?.companyResponse?.consumer?.pod?.value : "NA"}</div>
                </div>
                <div className='div-row'>
                  <div className='div-cell'>Consumer Specification</div>
                  <div className='div-cell'>:</div>
                  <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.consumer?.specification?.name ? myProfileDetails?.companyResponse?.consumer?.specification?.name : "NA"}</div>
                </div>
                <div className='div-row'>
                  <div className='div-cell'>Discom</div>
                  <div className='div-cell'>:</div>
                  <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.consumer?.discom?.discom ? myProfileDetails?.companyResponse?.consumer?.discom?.discom : "NA"}</div>
                </div>
                {/* <div className='div-row'>
                  <div className='div-cell'>Discom Voltage Level</div>
                  <div className='div-cell'>:</div>
                  <div className='div-cell div-cell-black'>{myProfileDetails?.companyResponse?.consumer?.discom?.voltageLevels[0].level ? myProfileDetails?.companyResponse?.consumer?.discom?.voltageLevels[0].level : "NA"}</div>
                </div> */}
              </div>
            </Tab>)}
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default EditProfile;
